import { themeOptions } from 'assets/styles/theme';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  /* O container do passo (FormContainer) esconde o overflow; com muitos
     arquivos a grade passa da altura disponível, então o scroll fica aqui. */
  max-height: 100%;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ccc;
  }
`;

interface LabelProps {
  marginTop: number;
}

export const Label = styled.label<LabelProps>`
  margin-top: ${(props) => props.marginTop}px;
  width: 100%;
  max-width: 370px;

  input {
    display: none;
  }

  > span {
    display: inline-flex;
    width: 100%;
  }
`;

export const FilesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 110px);
  gap: 10px;
  justify-content: center;
  margin: 8px 0 16px;
  width: 100%;
`;

interface TileProps {
  image?: string;
}

export const Tile = styled.div<TileProps>`
  position: relative;
  width: 110px;
  height: 110px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid ${themeOptions.palette.text.disabled};
  background-color: #fff;
  background-image: ${(props) => (props.image ? `url(${props.image})` : 'none')};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TileBadge = styled.span`
  font-weight: 700;
  font-size: 14px;
  color: ${themeOptions.palette.error.main};
  letter-spacing: 1px;
`;

export const TileFileName = styled.span`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 2px 4px;
  font-size: 10px;
  color: #fff;
  background: rgba(0, 0, 0, 0.55);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

interface OverlayProps {
  tone?: 'neutral' | 'error';
}

export const TileOverlay = styled.div<OverlayProps>`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  padding: 4px;
  background: ${(props) =>
    props.tone === 'error' ? 'rgba(211, 47, 47, 0.75)' : 'rgba(0, 0, 0, 0.55)'};

  button {
    color: #fff;
  }
`;

export const RemoveIcon = styled.img`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: 0.2s filter;

  &:hover {
    filter: brightness(0.9);
  }
`;

export const Buttons = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ErrorText = styled.p`
  margin: 8px 0 0;
  color: ${themeOptions.palette.error.main};
  font-size: 14px;
  text-align: center;
`;

export const HelperText = styled.p`
  margin: 8px 0 0;
  color: ${themeOptions.palette.text.secondary};
  font-size: 12px;
  text-align: center;
`;
